module.exports = __webpack_public_path__ + "img/323.3de494a1.jpg";